/**
 * boardsApi.js
 * ------------
 * API client for Boards Master using createMasterApiClient.
 * Connects directly to FastAPI backend /boards/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const boardsClient = createMasterApiClient('boards');
export default boardsClient;

export async function listBoards(params = {}) {
  return await boardsClient.list(params);
}

export async function getBoardDetail(boardId) {
  return await boardsClient.getById(boardId);
}

export async function createBoard(payload) {
  return await boardsClient.create(payload);
}

export async function updateBoard(boardId, payload) {
  return await boardsClient.update(boardId, payload);
}

export async function archiveBoard(boardId) {
  return await boardsClient.archive(boardId);
}

export async function deleteBoard(boardId) {
  return await boardsClient.remove(boardId);
}

export async function getBoardOptions() {
  return await boardsClient.getDropdownOptions();
}
